import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class AssemblySerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
